<template>
  <div class="app-main-content intelligent-booking">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :label="$t('CargoMsg.OCRRecognition')" name="tabOcr" :lazy="true">
          <tab-ocr
            ref="tabOcr"
            :active-tab-name="activeTabName"
            :source="details.source"
            :job-uuid="details.jobUuid"
            :doc-uuid="details.docUuid"
            @showDetails="handleShowDetails"
            @uploadEnd="uploadEndHandler"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('SeaExport.HangInTheAir')" name="tabPending" :lazy="true">
          <tab-pending
            ref="tabPending"
            :active-tab-name="activeTabName"
            :source="details.source"
            @supplementaryInformation="supplementaryInformation"
            @showDetails="handleShowDetails"
          />
        </el-tab-pane>
        <el-tab-pane ref="tabFinished" :label="$t('SeaExport.Completed')" name="tabFinished" :lazy="true">
          <tab-finished @showDetails="handleShowDetails" />
        </el-tab-pane>
        <el-tab-pane :label="$t('SeaExport.Dustbin')" name="tabTrash" :lazy="true">
          <tab-trash />
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--    信号旗详情-->
    <intelligent-booking-result-xhq
      v-if="details.visibleXhq"
      :visible="details.visibleXhq"
      :details="details.data"
      :source="details.source"
      @close="handleCloseDetails"
      @success="handleSaveSuccess"
    />
    <!--    美能华详情-->
    <intelligent-booking-result
      v-if="details.visibleMnh"
      :visible="details.visibleMnh"
      :details="details.data"
      :source="details.source"
      @close="handleCloseDetails"
      @success="handleSaveSuccess"
    />
    <!--    笔云托书详情-->
    <intelligent-booking-result-by
      v-if="details.visibleBy"
      :visible="details.visibleBy"
      :details="details.data"
      :source="details.source"
      @close="handleCloseDetails"
      @success="handleSaveSuccess"
    />
    <!--    笔云托书提单详情-->
    <intelligent-bill-result-by
      v-if="details.visibleBillBy"
      :visible="details.visibleBillBy"
      :details="details.data"
      :source="details.source"
      @close="handleCloseDetails"
      @success="handleSaveSuccess"
    />
    <!--    CW托书详情-->
    <intelligent-booking-result-cwmi
      v-if="details.visibleCwmi"
      :visible="details.visibleCwmi"
      :details="details.data"
      :source="details.source"
      @close="handleCloseDetails"
      @success="handleSaveSuccess"
    />
    <!--    多票托书详情-->
    <intelligent-booking-result-multi
      v-if="details.visibleMulti"
      :visible="details.visibleMulti"
      :detail-list="details.dataList"
      :source="details.source"
      @close="handleCloseDetails"
      @success="handleSaveSuccessMulti"
      @copyIntelligentDocument="copyIntelligentDocumentFunc"
    />
  </div>
</template>

<script>
import TabOcr from '@/views/cargo/v0/ToolAssistant/ocr/components/TabOcr'
import TabPending from '@/views/cargo/v0/ToolAssistant/ocr/components/TabPending'
import TabFinished from '@/views/cargo/v0/ToolAssistant/ocr/components/TabFinished'
import TabTrash from '@/views/cargo/v0/ToolAssistant/ocr/components/TabTrash'
import IntelligentBookingResult from '@/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResult'
import IntelligentBookingResultXhq from '@/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResultXhq'
import IntelligentBookingResultBy from '@/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResultBy'
import IntelligentBillResultBy from '@/views/cargo/v0/ToolAssistant/ocr/IntelligentBillResultBy'
import IntelligentBookingResultCwmi from '@/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResultCwmi'
import {
  INTELLIGENT_DOCUMENT_SOURCE_11, INTELLIGENT_DOCUMENT_SOURCE_4,
  SENDING_0, SENDING_1,
  SENDING_2, SENDING_4, SENDING_5, SENDING_7,
  SENDING_BY,
  SENDING_CWMI,
  SENDING_XHQ2
} from '@/class/cargo/model/parameters/SystemConstants'
import IntelligentBookingResultMulti from '@/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResultMulti'
import { deepClone } from '@/utils'

export default {
  name: 'OcrRecognition',
  components: {
    IntelligentBookingResult, TabOcr, TabTrash, TabFinished, TabPending,
    IntelligentBookingResultXhq, IntelligentBookingResultBy, IntelligentBillResultBy, IntelligentBookingResultCwmi, IntelligentBookingResultMulti },
  props: {
    // recognitionType: {
    //   type: Number,
    //   default: 0
    // },
    source: {
      type: Number,
      default: INTELLIGENT_DOCUMENT_SOURCE_11.code
    }
  },
  data() {
    return {
      activeTabName: 'tabOcr',
      details: {
        data: {},
        visibleMnh: false,
        visibleXhq: false,
        visibleBy: false,
        visibleBillBy: false,
        visibleCwmi: false,
        from: '',
        SENDING_2,
        source: INTELLIGENT_DOCUMENT_SOURCE_11.code, // 来源
        jobUuid: '', // 业务uuid
        docUuid: '', // 提单uuid
        dataList: [],
        visibleMulti: false
        // recognitionType: 0
      }
    }
  },
  activated() {},
  async created() {
    this.initSource()
  },
  methods: {
    initSource() {
      // console.log('this.source:', this.source)
      // console.log('this.$route.params.source:', this.$route.query.source)
      const query = this.$route.query
      this.details.source = this.source
      if (query.source) {
        this.details.source = query.source
        this.details.jobUuid = query.uuid
        this.details.docUuid = query.docUuid
      }
      delete this.$route.query.source
      // console.log('this.details.source:', this.details.source)
      this.$nextTick(() => {
        this.$refs.tabOcr.init()
      })
    },
    handleShowDetails(e) {
      this.details.from = e.from
      this.details.data = e.params
      this.details.source = e.params.source
      if (e.params.identificationChannel === SENDING_XHQ2.code) {
        this.details.visibleXhq = true
      } else if (e.params.identificationChannel === SENDING_BY.code) {
        if (e.params.identificationType === SENDING_2.code) {
          this.details.visibleBillBy = true
        } else {
          this.details.visibleBy = true
        }
      } else if (e.params.identificationChannel === SENDING_CWMI.code) {
        if ([SENDING_0.code, SENDING_1.code, SENDING_2.code, SENDING_4.code, SENDING_5.code, SENDING_7.code].indexOf(e.params.identificationType) > -1) {
          this.details.dataList = [deepClone(e.params)]
          this.details.visibleMulti = true
        } else {
          this.details.visibleCwmi = true
        }
      } else {
        this.details.visibleMnh = true
      }
    },
    uploadEndHandler() {
      this.activeTabName = 'tabPending'
    },
    handleCloseDetails() {
      this.closeAll()
    },
    closeAll() {
      this.details.visibleXhq = false
      this.details.visibleBy = false
      this.details.visibleBillBy = false
      this.details.visibleMnh = false
      this.details.visibleCwmi = false
      this.details.visibleMulti = false
    },
    handleSaveSuccess() {
      this.closeAll()
      this.$refs[this.details.from].fetchData()
    },
    handleSaveSuccessMulti() {
      this.closeAll()
      this.$refs[this.details.from].fetchData(false)
    },
    copyIntelligentDocumentFunc(res) {
      this.closeAll()
      setTimeout(() => {
        const e = {
          from: 'tabPending',
          params: res,
          source: res.source
        }
        this.handleShowDetails(e)
      }, 200)
    },
    // 补充信息
    supplementaryInformation(e) {
      // 记录当前tab
      this.details.from = e.from
      this.details.dataList = deepClone(e.selectedRows)
      this.details.visibleMulti = true
    }
  }
}
</script>

<style scoped>

</style>
